// extracted by mini-css-extract-plugin
export default {"cls1":"Autocomplete-cls1__caa2839ef655bc9f5326","cls2":"Autocomplete-cls2___f54e9cdc338b004cc9c Autocomplete-cls1__caa2839ef655bc9f5326"};